enum EnemyType {
  SMALL_HAMSTER1 = "SMALL_HAMSTER1",
  SMALL_HAMSTER2 = "SMALL_HAMSTER2",
  FAT_HAMSTER = "FAT_HAMSTER",
  SUIT_HAMSTER = "SUIT_HAMSTER",
  VAMPIRE_HAMSTER = "VAMPIRE_HAMSTER",
  HAMSTER_SWARM = "HAMSTER_SWARM",
  SNAKE1 = "SNAKE1",
  SNAKE2 = "SNAKE2",
  CACTUS = "CACTUS",
  SCORPION = "SCORPION",
  SCORPION_SWARM = "SCORPION_SWARM",
  SCORPION_BOSS = "SCORPION_BOSS",
  VULTURE = "VULTURE",
  VULTURE_SWARM = "VULTURE_SWARM",
  LIZARD_HAMSTER = "LIZARD_HAMSTER",
  GOLEM = "GOLEM",
  GOLEM_BOSS = "GOLEM_BOSS",
  REPTILE = "REPTILE",
  WARRIOR_HAMSTER = "WARRIOR_HAMSTER",
  KING_HAMSTER = "KING_HAMSTER",
  DEATH = "DEATH",
  CAMEL = "CAMEL",
  CAMEL_CARAVAN = "CAMEL_CARAVAN", 
  CHICKEN = "CHICKEN",
  CHICKEN_SWARM = "CHICKEN_SWARM",
  DUCK = "DUCK",
  SPIDER = "SPIDER",
  SPIDER_SWARM = "SPIDER_SWARM",
  BEE = "BEE",
  BEE_SWARM = "BEE_SWARM",
  TIGER = "TIGER",
  GORILLA = "GORILLA",
  RHINOCEROS = "RHINOCEROS",
  DARK_KNIGHT = "DARK_KNIGHT",
  CROCODILE = "CROCODILE",
  GREEN_GOLEM = "GREEN_GOLEM",
  LION = "LION",
  TREANT = "TREANT",
  SKELETON = "SKELETON",
  MOUSEMAN = "MOUSEMAN",
  MOUSEMAN2 = "MOUSEMAN2",
  WOLF = "WOLF",
}

export default EnemyType;
